import React, { useContext } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { NaviItem } from "../../types/naviItem";
import STBottomNav from "../../assets/styles/organisms/footer.module.scss";
import { Link } from "@material-ui/core";
import { UnreadMessageContext } from "../../providers/ChatProvider";
import { SiteContext } from "../../providers/SiteProvider";

const BottomNavigationItem: React.FC<NaviItem> = (props: NaviItem) => {
  const location = useLocation();
  const { unreadCount } = useContext(UnreadMessageContext);
  const isChat = useContext(SiteContext).isChat;
  const searchParams = new URLSearchParams(location.search);

  return (
    <>
      {props.url.match(/^https?:\/\//) ? (
        <Link
          className={STBottomNav.nav_item}
          color="secondary"
          href={props.url}
          target="_blank"
        >
          <img src={props.icon} alt={props.name} className={STBottomNav.icon} />
          <h5>{props.name}</h5>
        </Link>
      ) : (
        <NavLink
          to={props.url}
          exact
          className={(isActive) =>
            STBottomNav.nav_item +
            " " +
            (isActive && !searchParams.has("list")
              ? STBottomNav.nav_item_active
              : STBottomNav.nav_item_inactive)
          }
        >
          <div
            className={
              location.pathname === props.url && !searchParams.has("list")
                ? STBottomNav.nav_item_inner_active
                : STBottomNav.nav_item_inner_inactive
            }
          >
            <img
              src={props.icon}
              alt={props.name}
              className={
                location.pathname === props.url && !searchParams.has("list")
                  ? STBottomNav.iconActive
                  : STBottomNav.icon
              }
            />
            <h5
              className={
                location.pathname === props.url && !searchParams.has("list")
                  ? STBottomNav.textActive
                  : STBottomNav.text
              }
            >
              {props.name}
            </h5>
            {props.url === "/chat" && unreadCount > 0 && isChat && (
              <span className={STBottomNav.chat_notification}></span>
            )}
          </div>
        </NavLink>
      )}
    </>
  );
};

export default BottomNavigationItem;
